import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズのLaborCoreロゴアイコン
 */
export function ProductLogoMediumLaborCore({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        d="M21.529 20.5768C21.529 20.3395 21.3522 20.1371 21.1151 20.125C21.0184 20.1201 20.921 20.1176 20.8231 20.1176H13.7642C10.6455 20.1176 8.11719 22.6459 8.11719 25.7647V27.8823C8.11719 28.2722 8.43322 28.5882 8.82307 28.5882H21.0584C21.3183 28.5882 21.529 28.3775 21.529 28.1176V20.5768Z"
        fill="#57D7D9"
      />
      <path
        d="M23.57 20.8295C23.2785 20.667 22.9407 20.8925 22.9407 21.2263V28.1176C22.9407 28.3775 23.1514 28.5882 23.4113 28.5882H24.8231C24.5632 28.5882 24.3525 28.3775 24.3525 28.1176V27.647C24.3525 27.3871 24.5632 27.1764 24.8231 27.1764H25.9995C26.2594 27.1764 26.4701 26.9657 26.4701 26.7058V26.2353C26.4701 25.9754 26.2594 25.7647 25.9995 25.7647H24.8231C24.5632 25.7647 24.3525 25.554 24.3525 25.2941V24.8235C24.3525 24.5636 24.5632 24.3529 24.8231 24.3529H25.6852C25.9927 24.3529 26.2178 24.0621 26.1094 23.7743C26.0325 23.5701 25.944 23.3715 25.8449 23.1793C25.7678 23.03 25.6112 22.9411 25.4432 22.9411H24.8231C24.5632 22.9411 24.3525 22.7304 24.3525 22.4705V22C24.3525 21.749 24.4117 21.3971 24.211 21.2464C24.0076 21.0936 23.7934 20.9542 23.57 20.8295Z"
        fill="#57D7D9"
      />
      <path
        d="M22.2348 13.7647C22.2348 16.4936 20.0226 18.7058 17.2937 18.7058C14.5647 18.7058 12.3525 16.4936 12.3525 13.7647C12.3525 11.0357 14.5647 8.82349 17.2937 8.82349C20.0226 8.82349 22.2348 11.0357 22.2348 13.7647Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.2954 18C28.4826 18 28.6621 18.0743 28.7945 18.2067L31.2046 20.6167C31.3369 20.7491 31.4113 20.9287 31.4113 21.1159V30C31.4113 30.3898 31.0953 30.7058 30.7054 30.7058H23.6466C23.2568 30.7058 22.9407 30.3898 22.9407 30V18.7058C22.9407 18.316 23.2568 18 23.6466 18H28.2954ZM24.3525 22C24.3525 21.7401 24.5632 21.5294 24.8231 21.5294H29.529C29.7889 21.5294 29.9995 21.7401 29.9995 22V22.4705C29.9995 22.7304 29.7889 22.9411 29.529 22.9411H24.8231C24.5632 22.9411 24.3525 22.7304 24.3525 22.4705V22ZM24.8231 24.3529C24.5632 24.3529 24.3525 24.5636 24.3525 24.8235V25.2941C24.3525 25.554 24.5632 25.7647 24.8231 25.7647H29.529C29.7889 25.7647 29.9995 25.554 29.9995 25.2941V24.8235C29.9995 24.5636 29.7889 24.3529 29.529 24.3529H24.8231ZM24.8231 27.1764C24.5632 27.1764 24.3525 27.3871 24.3525 27.647V28.1176C24.3525 28.3775 24.5632 28.5882 24.8231 28.5882H29.529C29.7889 28.5882 29.9995 28.3775 29.9995 28.1176V27.647C29.9995 27.3871 29.7889 27.1764 29.529 27.1764H24.8231Z"
        fill="#FCFCFD"
      />
      <path
        d="M31.2105 20.6227C31.2846 20.6968 31.2321 20.8235 31.1273 20.8235H29.0584C28.7985 20.8235 28.5878 20.6128 28.5878 20.3529V18.284C28.5878 18.1792 28.7145 18.1267 28.7886 18.2008L31.2105 20.6227Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
